<template lang="pug">
.wrapper-message
  .icon &#10008;
  .title-message {{ messages.title }}
  .subtitle-message {{ messages.subtitle }}
</template>
<script>
export default {
    props: {
        messages: { type: Object, required: true }
    }
}
</script>

<style lang="scss" scoped>
.wrapper-message {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .title-message {
        opacity: 0.9;
    }
    .subtitle-message {
        opacity: 0.8;
        line-height: 2;
    }
}

//- Style BIF FISH 🐳
// .wrapper-message {
//     .icon {
//         font-size: 48px;
//         color: #fe4277;
//     }
//     .title-message {
//         font-size: 16px;
//         color: #fff;
//         opacity: 0.9;
//     }
//     .subtitle-message {
//         font-size: 14px;
//         color: #eaeaea;
//         opacity: 0.8;
//         line-height: 2;
//     }
// }
</style>
